let timelineElements = [
  {
    id: 1,
    title: "Region-8 Cross Sectional Student Initiatives Booster Program",
    location: "November 26th 2021",
    description:
      "We organized an e-conference concerning 'metrology in medicine' that was presented by Dr.Almir Badnjevic on GoogleMeet platform. He is one of the founders of an idea to include Medical Devices with Measuring Function into the Legal Metrology framework and establishing traceability of medical measurements. This conference falls in the context of the R8 cross regional student initiatives booster program, in which EMBS INSAT SBC takes part.",
    buttonText: "Visit the link",
    date: "November 26th 2021",
    link:"https://www.facebook.com/IeeeInsatStudentBranch/posts/4720888191283046",
    icon: "dna",
  },
  {
    id: 2,
    title: "IEEEDAY21    ",
    location: "October 13th 2021",
    description:
      "IEEEDAY is a celebration held every year in all IEEE student branches worldwide. It is an occasion for each student branch chapter to present their field, activities and recruit new members. we, EMBS INSAT SBC, held our stand in the university hall and spent unforgettable moments with our old and new members.",
    buttonText: "Visit the link",
    date: "October 13th 2021     ",
    link: "https://www.facebook.com/EMBS.INSAT/posts/843926509621948?__cft__[0]=AZVH4gATo-SbXdXIislyE5dP6bDGfFEfL0sQZ63P8dkneXVwUkBJ2LtXD2CQYiY9CRF079Y55qHYM0aOo1E1ndycUkJ27ljv6utntODdyNWqaYWeRALN8P5a73NrIMiW43J2QLLwDly-9AgN2-9MPN0i&__tn__=%2CO%2CP-R",
    icon: "biology",
  },
  {
    id: 3,
    title: "Octobre rose (Pink October)",
    location: "October 8th 2021",
    description:
      "Pink October is a month of mobilization against breast cancer. On the occasion of the 25th anniversary INSAT, IEEE INSAT EMBS SBC organized, in collaboration with IEEE INSAT WIE SBAG, a conference on breast cancer. It is the most diagnosed cancer in women worldwide. However, it ranks among the cancers with the highest chances of recovery. We talked about it with Mrs. Nesrine Ben Khedija author of “Le guide de l’espoir”, and survivor of breast cancer. She guided us towards the luminous path of all those who have found themselves in the dark whirlpool of breast cancer. We concluded the conference with a debate around the famous short film 'La lionne ou l'autruche'" ,
    buttonText: "Visit the link",
    date: "October 8th 2021    ",
    link:"https://www.facebook.com/EMBS.INSAT/posts/838129586868307?__cft__[0]=AZWpBeGixH4-HzVQo-37TW_AiYF_C2RIdG536Y16-XQnKQtasYSej5LSHDVEpU07iI5k7XhmBzd3iGm7w-S3rd6Q5-8hek_7qiiSTUj5mFsH3IOQDE0rSYEdH3jyBYVrx8UmAJVfD3_7Fdm_Tbx_-i-s6N6QEVQLTJmKLkaR35hsiq5i9_3iGYVCV4GsnRA_3-8&__tn__=%2CO%2CP-R",
    icon: "dna",
  },
  {
    id: 4,
    title: "Summer school 4.0    ",
    location: "10/11/12 of Septembre 2021    ",
    description:
      "We organized a series of workshops about 3 different topics that are really important in both of our fields of concern : medicine and biology.      ",
    buttonText: "Visit the link",
    date: "10/11/12 of Septembre 2021    ",
    link:"https://www.facebook.com/EMBS.INSAT/posts/827519167929349?__cft__[0]=AZXcsfPrCiNIs_mcspnpDzbsaOv4-MBsmD-Xil2-6tQLQ3fwjUgbQLevatOcSiK2_qoICevBsRG6cX7LxKJUeDIWCpLIryC-la8CpB-yeloirBgm3ND_t93mS3Al9HcatLH1Jpqnn49wj3OJFUrHGcRFthz7ZlWSsLqSuljpGKIEhg&__tn__=%2CO%2CP-R",
    icon: "biology",
  },
];

export default timelineElements;
